import Message from 'shared_components/message';
import { axiosLabAPI } from 'services/axios';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchSpecimensItems() {
	let specimensItem = [];

	try {

		const content = {
			method: API_GET_METHOD,
			url: `settings/specimen`,
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			specimensItem = data.RECORDS;
		} 
	} catch (e) {
		showMessage(e);
	}

	return specimensItem;
}

export async function createSpecimensItems(payload) {
	let createdSpecimen;

	try {
		const content = {
			method: API_POST_METHOD,
			url: `settings/specimen`,
			data: {
				p_specimen_name: payload.specimenName,
				p_specimen_sort: payload.specimenSort,
				p_is_active: payload.active,
			}
		}

		const response = await axiosLabAPI(content);
		const { data } = response;

		createdSpecimen = data;
	} catch (e) {
		showMessage(e);
	}

	return createdSpecimen;
}

export async function updateSpecimensItems(payload) {
	let updatedSpecimen;

	try {
		const content = {
			method: API_PUT_METHOD,
			url: `settings/specimen`,
			data: {
				p_specimen_id: payload.specimenID,
				p_specimen_name: payload.specimenName,
				p_specimen_sort: payload.specimenSort,
				p_is_active: payload.active,
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		updatedSpecimen = data;
	} catch (e) {
		showMessage(e);
	}

	return updatedSpecimen;
}

export async function applySorting(payload) {
	let sortResponse;
	const url = `settings/specimensorting`;

	try {
		const content = {
			method: API_PUT_METHOD,
			url,
			data: {
				p_specimen_sorting_array: JSON.stringify(payload)
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		sortResponse = data;

		// Show success message from API response
		if (data && data.STATUSCODE === 200 && data.MESSAGE) {
			Message.success({ message: data.MESSAGE });
		}
	} catch (error) {
		showMessage(error);
	}

	return sortResponse;
}